export interface WebSocketConfig {
  serverUrl: string;
  interviewId: string;
  fileName: string;
  onOpen?: () => void;
  onMessage?: (data: any) => void;
  onClose?: (event: CloseEvent) => void;
  onError?: (error: Event) => void;
}

export interface RecordingMetadata {
  recruiter: {
    first_name: string;
    last_name: string;
  };
  talent: {
    first_name: string;
    last_name: string;
  };
}

class WebSocketManager {
  private socket: WebSocket | null = null;

  connectWebSocket(config: WebSocketConfig): void {
    const {
      serverUrl,
      interviewId,
      fileName,
      onOpen,
      onMessage,
      onClose,
      onError,
    } = config;

    const wsUrl = `${serverUrl}/interviews/${interviewId}/stream?file_name=${fileName}&content_type=video/webm&transcribe_after_upload=true&summarize_after_transcription=true&generate_questions_after_summarization=true`;

    this.socket = new WebSocket(wsUrl);

    this.socket.onopen = () => {
      console.log("WebSocket connected:", wsUrl);
      onOpen?.();
    };

    this.socket.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        console.log("WebSocket message:", data);
        onMessage?.(data);
      } catch (error) {
        console.error("Error parsing WebSocket message:", error);
      }
    };

    this.socket.onerror = (error) => {
      console.error("WebSocket error:", error);
      onError?.(error);
    };

    this.socket.onclose = (event) => {
      console.log("WebSocket connection closed.");
      onClose?.(event);
    };
  }

  sendChunk(buffer: ArrayBuffer): boolean {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(buffer);
      return true;
    } else {
      console.warn("WebSocket is not open. Cannot send chunk.");
      return false;
    }
  }

  sendEndMessage(): void {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      console.log("WebSocket closing with 1000 code...");
      this.socket.close(1000, "Recording complete");
    }
  }

  getReadyState(): number | null {
    return this.socket?.readyState ?? null;
  }

  isConnected(): boolean {
    return this.socket?.readyState === WebSocket.OPEN;
  }

  disconnect(): void {
    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
  }
}

export const webSocketManager = new WebSocketManager();
